import { FlexColumn, Weight } from 'components'
import { useVisibility } from 'hooks/use-visibility-checker'
import React, { useEffect, useState } from 'react'
import { TooltipStateProps } from '../interface'
import { StyledText, StyledTitle, TooltipBody, Triangle, Wrapper } from '../style'

export const Tooltip: React.FC<TooltipStateProps> = ({
  className,
  children,
  title,
  content,
  triangle,
  color,
  fontColor,
  customPadding,
  openLeftSide,
  openLeftAmount,
  openRightAmount,
  active,
}) => {
  const [isActive, setActive] = useState(false)
  const [ref, left, top, right, bottom] = useVisibility()
  useEffect(() => {
    setActive(active)
  }, [active])
  return (
    <Wrapper className={className}>
      {isActive && (
        <TooltipBody
          ref={ref}
          infoIcon={!children}
          color={color}
          fontColor={fontColor}
          customPadding={customPadding}
          openLeftSide={openLeftSide}
          openLeftAmount={openLeftAmount}
          openRightAmount={openRightAmount}
          outOfBoundsTop={top}
          outOfBoundsBottom={bottom}
          outOfBoundsLeft={left}
          outOfBoundsRight={right}
        >
          {triangle && (
            <Triangle
              outOfBoundsBottom={bottom}
              outOfBoundsLeft={left}
              outOfBoundsRight={right}
              outOfBoundsTop={top}
              openLeftSide={openLeftSide}
            />
          )}
          <FlexColumn>
            {title && (
              <StyledTitle type={'four'} weight={Weight.Medium}>
                {title}
              </StyledTitle>
            )}
            <StyledText type={'small'} weight={Weight.Regular}>
              {content}
            </StyledText>
          </FlexColumn>
        </TooltipBody>
      )}
    </Wrapper>
  )
}
